import React from 'react';
import { useSession } from '@cordata/buffet';
import { Container } from 'reactstrap';
import { Navbar } from '~/components/common';
import { routes } from '~/utils';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
}) => {
  const { isAuthed } = useSession();

  return isAuthed ? (
    <>
      <Navbar routes={routes.filter(r => r.main)} />

      <Container fluid className="my-3">
        {children}
      </Container>
    </>
  ) : (
    <>
      {children}
    </>
  );
};

export default AppLayout;
